import {
  fetchHotel,
  fetchTaxiVoucher,
  fetchTaxiCompanies,
  updateOptionTaxiTranfer,
  updateTaxiTransferOption,
  sendTaxiTransferSMSToOthers,
  saveTaxiTransfer,
  issueTaxiTransferVoucher,
  storeFileRefreshment,
  storeReceipt,
  getInfoTaxi,
  getPricePersonTaxi,
  checkValidatorField,
  sendEmailExceedPrice
} from '@/api/service'
const getTaxi = (context) => {
  return fetchHotel().then((response) => {
    context.commit('TAXI_UPDATED', response)
    return context.state.Taxi
  })
}

const getTaxiVoucher = (context) => {
  return fetchTaxiVoucher().then((response) => {
    context.commit('TAXI_VOUCHER_UPDATED', response)
  })
}

const getTaxiCompanies = (context) => {
  return fetchTaxiCompanies().then((response) => {
    if (!_.isEmpty(response)) {
      context.commit('TAXI_COMPANIES_UPDATED', response)
    }
  })
}

const updateOptionTaxi = (context, data) => {
  return updateOptionTaxiTranfer(data).then((response) => {
    return response
  })
}
const updateTaxiOption = (context, data) => {
  return updateTaxiTransferOption(data).then((response) => {
    return response
  })
}
const sendSMSToOthers = (context, data) => {
  return sendTaxiTransferSMSToOthers(data).then((response) => {
    return response
  })
}
const saveTaxi = (context, data) => {
  return saveTaxiTransfer(data).then((response) => {
    return response
  })
}

const issueTaxi = (context, data) => {
  return issueTaxiTransferVoucher(data).then((response) => {
    return response
  })
}

const uploadImg = (context, data) => {
  return storeFileRefreshment(data).then((response) => {
    return response
  })
}

const saveInfoPax = (context, data) => {
  return storeReceipt(data).then((response) => {
    return response
  })
}

const getTaxiInfo = (context, data) => {
  getInfoTaxi(data).then((response) => {
    context.commit('TAXI_INFO', response)
  })
}

const getPriceTaxi = (context) => {
  getPricePersonTaxi().then((response) => {
    context.commit(
      'TAXI_PRICE',
      _.filter(response, function (o) {
        return o.service_id == 4
      })
    )
  })
}

const checkValidator = (context, data) => {
  return checkValidatorField(data).then((response) => {
    return response
  })
}

const sendEmailExceeds = (context, data) => {
  return sendEmailExceedPrice(data).then((response) => {
    return response
  })
}

export default {
  getTaxi,
  getTaxiVoucher,
  getTaxiCompanies,
  updateOptionTaxi,
  updateTaxiOption,
  sendSMSToOthers,
  saveTaxi,
  issueTaxi,
  uploadImg,
  saveInfoPax,
  getTaxiInfo,
  getPriceTaxi,
  checkValidator,
  sendEmailExceeds
}
